import { render, staticRenderFns } from "./CustomersChurnChart.vue?vue&type=template&id=3d33b5e2&scoped=true&"
import script from "./CustomersChurnChart.vue?vue&type=script&lang=js&"
export * from "./CustomersChurnChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomersChurnChart.vue?vue&type=style&index=0&id=3d33b5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d33b5e2",
  null
  
)

export default component.exports